module.exports = __webpack_public_path__ + "img/vip-help.5364bf50.png";